import type Splide from '@splidejs/splide';
import type { Component, JSX } from 'solid-js';
import classNames from 'classnames';
import { For, Show, splitProps } from 'solid-js';
import { Transition, TransitionGroup } from 'solid-transition-group';

type Props = {
  list: { title: string }[];
  carousel: Splide;
} & JSX.HTMLAttributes<HTMLDivElement>;

const Breadcrumb: Component<Props> = (props) => {
  const [{ carousel, list, class: className }, all] = splitProps(props, [
    'carousel',
    'list',
    'class',
  ]);

  const transitionName = () => (list.length > 0 ? 'slide-fade' : 'slide-fade-fast');

  return (
    <div class={classNames('border-t border-black/8', className)} {...all}>
      <ul
        class={classNames('mobile-navigation__breadcrumb', {
          'mobile-navigation__breadcrumb--has-items': list.length > 0,
        })}
        onClick={() => carousel.go('-2')}
      >
        <Transition name={transitionName()}>
          <Show when={list.length > 0}>
            <li>
              <button type="button" class="w-8">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="square"
                    d="m12.5 5-5 5 5 5"
                  />
                </svg>
              </button>
            </li>
          </Show>
        </Transition>

        <TransitionGroup name={transitionName()}>
          <For each={list}>
            {(item) => (
              <li>
                <button type="button">{item.title}</button>
              </li>
            )}
          </For>
        </TransitionGroup>
      </ul>
    </div>
  );
};

export default Breadcrumb;
